import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
//管理vuex
const store = new Vuex.Store({
	state: {
		show_error_msg: false, //显示错误信息
		is_loading: false, //显示loading
		is_get_gps_loading: false, //是否显示获取地理位置的loading
		init_loading: false, //jm对象初始化数据是否执行完毕，执行完毕后再渲染页面
		adpter_scale: 1,
		loadin_is_show: true,
		rule_content: "",
		isShare:false,
	},
	mutations: {
		updataLoading(state, status) {
			state.is_loading = status;
		},
		updataInitLoading(state, status) {
			state.init_loading = status;
		},
		updataShowErrorMsg(state, status) {
			state.show_error_msg = status;
		},
		updataGpsLoading(state, status) {
			state.is_get_gps_loading = status;
		},
		updataAdpterScale(state, status) {
			state.adpter_scale = status;
		},
		updataLoadingIsValue(state, status) {
			state.loadin_is_show = status
		},
		updataRuleContent(state, status) {
			state.rule_content = status;
		},
		changeIsShare(state,status){
			state.isShare = status
		},
	},
	actions: {
		
	}
});
export default store;


// WEBPACK FOOTER //
// ./src/utils/store.js